export default "__VITE_PUBLIC_ASSET__00efd740__"